/* Order page copy — RU / UZ (Latin) / EN. Same voice as the main site: short, confident. */
export const DICT = {
  ru: {
    'meta.title': 'Конструктор дизайна в 3D — FunMode',
    'meta.desc': 'Собери дизайн для чехла телефона, IQOS, кейса AirPods или геймпада: модель, стиль, цвета, иконки, свой рисунок — и смотри результат в 3D. Ташкент.',
    'seo.home': 'Главная',
    'o.back': 'На главную',
    'o.h1': 'Собери <span class="hl">свой дизайн.</span>',
    'o.lead': 'Выбирай — модель справа меняется сразу. Крути её, смотри со всех сторон.',
    'o.hint': 'Крути пальцем или мышкой · щипок — зум',
    'v.front': 'Дизайн', 'v.side': 'Сбоку', 'v.back': 'Сзади', 'v.spin': '360°',
    'o.disclaimer': 'Это 3D-превью. Перед работой пришлём финальный макет и цену — начнём только после твоего «да».',
    'o.noWebgl': '3D на этом устройстве не поддерживается — показываем плоский макет.',
    'o.toForm': 'К оформлению',

    's.device': 'Девайс', 's.style': 'Стиль', 's.colors': 'Цвета', 's.icons': 'Иконки', 's.custom': 'Свой дизайн и надпись', 's.finish': 'Финиш', 's.contact': 'Контакты',
    'cat.phone': 'Телефон', 'cat.phone.d': 'чехол',
    'cat.iqos': 'IQOS', 'cat.iqos.d': 'корпус',
    'cat.earbuds': 'Наушники', 'cat.earbuds.d': 'кейс',
    'cat.gamepad': 'Геймпад', 'cat.gamepad.d': 'корпус',
    'cat.phone.note': 'Печатаем на чехле — сам телефон не трогаем.',
    'cat.iqos.note': 'Красим корпус. Кнопки, экран и контакты не закрываем.',
    'cat.earbuds.note': 'Красим кейс. Индикатор и разъём остаются чистыми.',
    'cat.gamepad.note': 'Красим корпус. Кнопки и стики не трогаем.',
    'f.brand': 'Бренд', 'f.model': 'Модель', 'f.otherBrand': 'Другой', 'f.otherModel': 'Нет в списке',
    'f.otherPh': 'Напиши бренд и модель',

    'mode.street': 'STREET', 'mode.clean': 'CLEAN', 'mode.splash': 'SPLASH', 'mode.idea': 'СВОЯ ИДЕЯ',
    'mode.street.d': 'Теги, подтёки, корона.', 'mode.clean.d': 'Минимум: имя, знак, линия.',
    'mode.splash.d': 'Брызги по всему корпусу.', 'mode.idea.d': 'Твой рисунок — загрузи файл.',

    'f.base': 'Корпус', 'f.accent': 'Акцент', 'f.detail': 'Иконки и надпись', 'f.custom': 'Свой цвет',
    'f.iconsHint': 'Наши иконки — выбери до 8.', 'f.size': 'Размер', 'f.shuffle': 'Перемешать',
    'f.upload': 'Загрузи свой рисунок', 'f.uploadHint': 'PNG, JPG, WEBP, SVG или PDF · до 15 МБ',
    'f.uploadNeed': 'Для режима «Своя идея» нужен файл.',
    'f.remove': 'Убрать', 'f.imgScale': 'Размер', 'f.imgX': 'Влево — вправо', 'f.imgY': 'Вверх — вниз',
    'f.pdfNote': 'PDF в 3D не показываем — посмотрим его сами и пришлём макет.',
    'f.text': 'Надпись', 'f.textPh': 'Например, имя',
    'fin.gloss': 'Глянец', 'fin.matte': 'Матовый',

    'f.name': 'Имя', 'f.phone': 'Телефон', 'f.tg': 'Telegram', 'f.optional': 'необязательно',
    'f.delivery': 'Доставка', 'del.courier': 'Курьер по Ташкенту', 'del.post': 'Доставка по Узбекистану',
    'f.city': 'Город', 'f.address': 'Адрес', 'f.comment': 'Комментарий', 'f.commentPh': 'Пожелания, детали, вопросы',
    'f.consent': 'Согласен с <a href="/offer" target="_blank" rel="noopener">условиями заказа</a> и <a href="/privacy" target="_blank" rel="noopener">обработкой моих данных</a>',
    'o.submit': 'Отправить заказ', 'o.sending': 'Отправляем…',

    'e.name': 'Напиши имя.', 'e.phone': 'Проверь номер телефона.', 'e.model': 'Укажи бренд и модель.',
    'e.upload': 'Загрузи файл для режима «Своя идея».', 'e.consent': 'Нужно согласие на обработку данных.',
    'e.file': 'Файл не подходит: PNG, JPG, WEBP, SVG или PDF до 15 МБ.',
    'e.server': 'Не получилось отправить. Попробуй ещё раз чуть позже.', 'e.rate': 'Слишком много заказов подряд. Попробуй позже.',

    'ok.title': 'Заказ принят!', 'ok.num': 'Номер заказа', 'ok.text': 'Скоро свяжемся, пришлём финальный макет и цену. Работу начнём после твоего подтверждения и предоплаты 50%.',
    'ok.home': 'На главную', 'ok.again': 'Собрать ещё один',
    'view.banner': 'Просмотр заказа', 'view.login': 'Войди в админку, чтобы открыть заказ.', 'view.admin': 'Открыть в админке',
    'ok.tg': 'Получать статус в Telegram', 'ok.linked': 'Статус заказа будем присылать в этот чат ✅',
    'share.btn': 'Поделиться дизайном', 'share.title': 'Поделись дизайном',
    'share.text': 'Ссылка открывает этот дизайн в 3D. Картинку можно выложить в сторис.',
    'share.send': 'Отправить', 'share.copy': 'Скопировать ссылку', 'share.copied': 'Ссылка скопирована ✓', 'share.save': 'Скачать картинку',
    'share.hold': 'Нажми и удерживай картинку, чтобы сохранить.', 'share.close': 'Закрыть',
    'share.msg': 'Смотри, какой дизайн я собрал в FunMode', 'share.mine': 'Мой дизайн', 'share.cta': 'Собери свой на funmode.uz',
    'share.noImage': 'Твой рисунок в ссылку не попадает — только цвета, иконки и надпись.',
  },

  uz: {
    'meta.title': '3D dizayn konstruktori — FunMode',
    'meta.desc': 'Telefon g‘ilofi, IQOS, AirPods keysi yoki geympad uchun dizayn yig‘: model, uslub, ranglar, ikonkalar, o‘z rasming — natijani 3D-da ko‘r. Toshkent.',
    'seo.home': 'Bosh sahifa',
    'o.back': 'Bosh sahifa',
    'o.h1': 'Dizayningni <span class="hl">yig‘.</span>',
    'o.lead': 'Tanla — model darhol o‘zgaradi. Aylantir, har tomondan ko‘r.',
    'o.hint': 'Barmoq yoki sichqoncha bilan aylantir · chimdish — zum',
    'v.front': 'Dizayn', 'v.side': 'Yondan', 'v.back': 'Orqadan', 'v.spin': '360°',
    'o.disclaimer': 'Bu 3D-namuna. Ishdan oldin yakuniy maket va narxni yuboramiz — faqat sening «ha» javobingdan keyin boshlaymiz.',
    'o.noWebgl': 'Bu qurilmada 3D ishlamaydi — tekis maketni ko‘rsatamiz.',
    'o.toForm': 'Buyurtma',

    's.device': 'Qurilma', 's.style': 'Uslub', 's.colors': 'Ranglar', 's.icons': 'Ikonkalar', 's.custom': 'O‘z dizayning va yozuv', 's.finish': 'Qoplama', 's.contact': 'Kontaktlar',
    'cat.phone': 'Telefon', 'cat.phone.d': 'g‘ilof',
    'cat.iqos': 'IQOS', 'cat.iqos.d': 'korpus',
    'cat.earbuds': 'Quloqchin', 'cat.earbuds.d': 'keys',
    'cat.gamepad': 'Geympad', 'cat.gamepad.d': 'korpus',
    'cat.phone.note': 'G‘ilofga chizamiz — telefonning o‘ziga tegmaymiz.',
    'cat.iqos.note': 'Korpusni bo‘yaymiz. Tugmalar, ekran va kontaktlar ochiq qoladi.',
    'cat.earbuds.note': 'Keysni bo‘yaymiz. Indikator va ulagich toza qoladi.',
    'cat.gamepad.note': 'Korpusni bo‘yaymiz. Tugmalar va stiklarga tegmaymiz.',
    'f.brand': 'Brend', 'f.model': 'Model', 'f.otherBrand': 'Boshqa', 'f.otherModel': 'Ro‘yxatda yo‘q',
    'f.otherPh': 'Brend va modelni yoz',

    'mode.street': 'STREET', 'mode.clean': 'CLEAN', 'mode.splash': 'SPLASH', 'mode.idea': 'O‘Z G‘OYANG',
    'mode.street.d': 'Teglar, oqimlar, toj.', 'mode.clean.d': 'Minimal: ism, belgi, chiziq.',
    'mode.splash.d': 'Butun korpus bo‘ylab sachratqilar.', 'mode.idea.d': 'O‘z rasming — faylni yukla.',

    'f.base': 'Korpus', 'f.accent': 'Aksent', 'f.detail': 'Ikonka va yozuv', 'f.custom': 'O‘z ranging',
    'f.iconsHint': 'Bizning ikonkalar — 8 tagacha tanla.', 'f.size': 'O‘lcham', 'f.shuffle': 'Aralashtirish',
    'f.upload': 'O‘z rasmingni yukla', 'f.uploadHint': 'PNG, JPG, WEBP, SVG yoki PDF · 15 MB gacha',
    'f.uploadNeed': '«O‘z g‘oyang» rejimi uchun fayl kerak.',
    'f.remove': 'Olib tashlash', 'f.imgScale': 'O‘lcham', 'f.imgX': 'Chapga — o‘ngga', 'f.imgY': 'Yuqoriga — pastga',
    'f.pdfNote': 'PDF 3D-da ko‘rinmaydi — o‘zimiz ko‘rib, maket yuboramiz.',
    'f.text': 'Yozuv', 'f.textPh': 'Masalan, ism',
    'fin.gloss': 'Yaltiroq', 'fin.matte': 'Mat',

    'f.name': 'Ism', 'f.phone': 'Telefon', 'f.tg': 'Telegram', 'f.optional': 'ixtiyoriy',
    'f.delivery': 'Yetkazib berish', 'del.courier': 'Toshkent bo‘ylab kuryer', 'del.post': 'O‘zbekiston bo‘ylab yetkazish',
    'f.city': 'Shahar', 'f.address': 'Manzil', 'f.comment': 'Izoh', 'f.commentPh': 'Istaklar, tafsilotlar, savollar',
    'f.consent': '<a href="/uz/offer" target="_blank" rel="noopener">Buyurtma shartlari</a> va <a href="/uz/privacy" target="_blank" rel="noopener">ma’lumotlarimni qayta ishlash</a>ga roziman',
    'o.submit': 'Buyurtmani yuborish', 'o.sending': 'Yuborilmoqda…',

    'e.name': 'Ismingni yoz.', 'e.phone': 'Telefon raqamini tekshir.', 'e.model': 'Brend va modelni ko‘rsat.',
    'e.upload': '«O‘z g‘oyang» rejimi uchun fayl yukla.', 'e.consent': 'Ma’lumotlarni qayta ishlashga rozilik kerak.',
    'e.file': 'Fayl mos emas: PNG, JPG, WEBP, SVG yoki PDF, 15 MB gacha.',
    'e.server': 'Yuborib bo‘lmadi. Birozdan keyin qayta urinib ko‘r.', 'e.rate': 'Juda ko‘p buyurtma. Keyinroq urinib ko‘r.',

    'ok.title': 'Buyurtma qabul qilindi!', 'ok.num': 'Buyurtma raqami', 'ok.text': 'Tez orada bog‘lanamiz, yakuniy maket va narxni yuboramiz. Ishni tasdig‘ing va 50% oldindan to‘lovdan keyin boshlaymiz.',
    'ok.home': 'Bosh sahifa', 'ok.again': 'Yana bittasini yig‘ish',
    'view.banner': 'Buyurtmani ko‘rish', 'view.login': 'Buyurtmani ochish uchun admin panelga kir.', 'view.admin': 'Admin panelda ochish',
    'ok.tg': 'Holatini Telegramda olish', 'ok.linked': 'Buyurtma holatini shu chatga yuborib turamiz ✅',
    'share.btn': 'Dizaynni ulashish', 'share.title': 'Dizayningni ulash',
    'share.text': 'Havola shu dizaynni 3D-da ochadi. Rasmni storisga joylashing mumkin.',
    'share.send': 'Yuborish', 'share.copy': 'Havolani nusxalash', 'share.copied': 'Havola nusxalandi ✓', 'share.save': 'Rasmni yuklab olish',
    'share.hold': 'Saqlash uchun rasmni bosib turing.', 'share.close': 'Yopish',
    'share.msg': 'Qara, FunMode’da qanday dizayn yig‘dim', 'share.mine': 'Mening dizaynim', 'share.cta': 'O‘zingnikini funmode.uz da yig‘',
    'share.noImage': 'O‘z rasming havolaga kirmaydi — faqat ranglar, ikonkalar va yozuv.',
  },

  en: {
    'meta.title': '3D design configurator — FunMode',
    'meta.desc': 'Design a phone case, IQOS, AirPods case or gamepad: model, style, colors, icons, your own art — and see the result in 3D. Tashkent.',
    'seo.home': 'Home',
    'o.back': 'Home',
    'o.h1': 'Build <span class="hl">your design.</span>',
    'o.lead': 'Every pick updates the model right away. Spin it, check every side.',
    'o.hint': 'Drag to rotate · pinch to zoom',
    'v.front': 'Design', 'v.side': 'Side', 'v.back': 'Back', 'v.spin': '360°',
    'o.disclaimer': 'This is a 3D preview. Before we start, we send the final mockup and price — we only paint after your “yes”.',
    'o.noWebgl': '3D isn’t supported on this device — showing a flat mockup.',
    'o.toForm': 'Checkout',

    's.device': 'Device', 's.style': 'Style', 's.colors': 'Colors', 's.icons': 'Icons', 's.custom': 'Your art & text', 's.finish': 'Finish', 's.contact': 'Contacts',
    'cat.phone': 'Phone', 'cat.phone.d': 'case',
    'cat.iqos': 'IQOS', 'cat.iqos.d': 'shell',
    'cat.earbuds': 'Earbuds', 'cat.earbuds.d': 'case',
    'cat.gamepad': 'Gamepad', 'cat.gamepad.d': 'shell',
    'cat.phone.note': 'We print on the case — the phone itself stays untouched.',
    'cat.iqos.note': 'We paint the shell. Buttons, screen and contacts stay clear.',
    'cat.earbuds.note': 'We paint the case. The LED and port stay clean.',
    'cat.gamepad.note': 'We paint the shell. Buttons and sticks stay untouched.',
    'f.brand': 'Brand', 'f.model': 'Model', 'f.otherBrand': 'Other', 'f.otherModel': 'Not listed',
    'f.otherPh': 'Type brand and model',

    'mode.street': 'STREET', 'mode.clean': 'CLEAN', 'mode.splash': 'SPLASH', 'mode.idea': 'YOUR IDEA',
    'mode.street.d': 'Tags, drips, crown.', 'mode.clean.d': 'Minimal: name, mark, line.',
    'mode.splash.d': 'Splashes all over.', 'mode.idea.d': 'Your artwork — upload a file.',

    'f.base': 'Body', 'f.accent': 'Accent', 'f.detail': 'Icons & text', 'f.custom': 'Custom color',
    'f.iconsHint': 'Our icons — pick up to 8.', 'f.size': 'Size', 'f.shuffle': 'Shuffle',
    'f.upload': 'Upload your artwork', 'f.uploadHint': 'PNG, JPG, WEBP, SVG or PDF · up to 15 MB',
    'f.uploadNeed': '“Your idea” mode needs a file.',
    'f.remove': 'Remove', 'f.imgScale': 'Size', 'f.imgX': 'Left — right', 'f.imgY': 'Up — down',
    'f.pdfNote': 'PDFs don’t show in 3D — we’ll review it and send a mockup.',
    'f.text': 'Text', 'f.textPh': 'e.g. your name',
    'fin.gloss': 'Gloss', 'fin.matte': 'Matte',

    'f.name': 'Name', 'f.phone': 'Phone', 'f.tg': 'Telegram', 'f.optional': 'optional',
    'f.delivery': 'Delivery', 'del.courier': 'Courier in Tashkent', 'del.post': 'Shipping across Uzbekistan',
    'f.city': 'City', 'f.address': 'Address', 'f.comment': 'Comment', 'f.commentPh': 'Wishes, details, questions',
    'f.consent': 'I agree to the <a href="/en/offer" target="_blank" rel="noopener">terms of service</a> and the <a href="/en/privacy" target="_blank" rel="noopener">processing of my data</a>',
    'o.submit': 'Send order', 'o.sending': 'Sending…',

    'e.name': 'Enter your name.', 'e.phone': 'Check the phone number.', 'e.model': 'Enter the brand and model.',
    'e.upload': 'Upload a file for “Your idea” mode.', 'e.consent': 'Consent is required.',
    'e.file': 'Unsupported file: PNG, JPG, WEBP, SVG or PDF up to 15 MB.',
    'e.server': 'Couldn’t send the order. Please try again shortly.', 'e.rate': 'Too many orders in a row. Try again later.',

    'ok.title': 'Order received!', 'ok.num': 'Order number', 'ok.text': 'We’ll be in touch with the final mockup and price. Painting starts after you confirm and pay a 50% deposit.',
    'ok.home': 'Home', 'ok.again': 'Build another one',
    'view.banner': 'Order view', 'view.login': 'Log in to the admin panel to open this order.', 'view.admin': 'Open in admin',
    'ok.tg': 'Get status updates in Telegram', 'ok.linked': 'We’ll send order updates to this chat ✅',
    'share.btn': 'Share design', 'share.title': 'Share your design',
    'share.text': 'The link opens this design in 3D. Post the picture to your stories.',
    'share.send': 'Send', 'share.copy': 'Copy link', 'share.copied': 'Link copied ✓', 'share.save': 'Download picture',
    'share.hold': 'Press and hold the picture to save it.', 'share.close': 'Close',
    'share.msg': 'Look at the design I made with FunMode', 'share.mine': 'My design', 'share.cta': 'Make yours at funmode.uz',
    'share.noImage': 'Your own picture isn’t included in the link — only colours, icons and text.',
  },
};
